import { Profile } from '../profile'

export enum IdentityEvent {
    EMAIL_VERIFIED = 'pnIdEmailVerified',
    IDENTITY_CHANGE = 'pnIdChange', // fires on any identity change event (session start/stop etc.)
    IDENTITY_INIT = 'pnIdInit', // fires immediately with locally-stored profile
    SESSION_INIT = 'pnIdSession', // fires when an SSO session is confirmed active/inactive
    IDENTITY_PROFILE_INIT = 'pnIdProfileInit', // profile initialized
    IDENTITY_SESSION_PROFILE_INIT = 'pnIdIdentitySessionProfileInit', // profile loaded
    NEW_LOGIN = 'pnNewLogin', // fires when there is a new login
    PROVIDER_ID_ASSIGNED = 'pnProviderIdAssigned', // fires when identity provider assigns an ID for the user
    LOGIN_MODAL_READY = 'pnLoginModalReady',
    MP_READY = 'pnMpReady', // fires when mParticle becomes available
    COMMENT_LOGIN = 'pnCommentLogin', // when someone wants to login from commenting
    COMMENT_LOGOUT = 'pnCommentLogout', // when someone wants to logout from commenting
    IDENTITY_SIGNOUT = 'pnIdSignOut',
    NEW_REGISTRATION = 'pnNewRegistration', // fires when a new user successfully registers
    IDENTITY_LOGIN = 'pnExplicitLogin', // fires on a callback from the SSO on explicit login
    IDENTITY_READY = 'pnIdReady', // fires when the profile is fully loaded (with adlite)
    IDENTITY_PROFILE_UPDATED = 'pnIdProfileUpdated', // fires when the profile is fully loaded with adlite after signin
}

export interface IIdentityEvent<T = Profile> extends CustomEvent<T> {
    detail: T
}
